/* Shopify-only integration. The standalone HTML preview never loads this file. */
(() => {
  'use strict';
  const root = document.getElementById('nr-page');
  const configNode = document.getElementById('nr-config');
  if (!root || !configNode) return;
  const config = JSON.parse(configNode.textContent);
  if (config.preview) return;
  let pending = false;
  const button = root.querySelector('[data-checkout]');
  const status = root.querySelector('[data-checkout-status]');
  const selectionControls = [...root.querySelectorAll('input[name="nr-supply"], [data-mode-toggle]')];
  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root.addEventListener('night:checkout', async event => {
    if (pending) return;
    const selection = event.detail;
    if (!selection.variantId || (selection.mode === 'subscription' && !selection.sellingPlanId)) {
      status.textContent = 'This supply option is temporarily unavailable. Please choose another option or contact support@reventide.store.';
      return;
    }
    pending = true;
    button.disabled = true;
    selectionControls.forEach(control => { control.disabled = true; });
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Preparing your checkout…';
    let mayHaveAdded = false;
    try {
      const item = {id:selection.variantId, quantity:1};
      if (selection.mode === 'subscription') item.selling_plan = selection.sellingPlanId;
      mayHaveAdded = true;
      const response = await fetch(cartRoot + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})});
      const result = await response.json();
      if (!response.ok) { mayHaveAdded = false; throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this supply. Please try again.'); }
      const added = result.items && result.items[0];
      const actualPlan = added && added.selling_plan_allocation && added.selling_plan_allocation.selling_plan.id;
      if (!added || added.final_price !== selection.totalCents || String(added.variant_id) !== String(selection.variantId) || (selection.mode === 'subscription' ? String(actualPlan) !== String(selection.sellingPlanId) : Boolean(actualPlan))) {
        throw new Error('Your selection needs a quick review. Please check your cart before continuing.');
      }
      window.location.assign(cartRoot + 'checkout');
    } catch (error) {
      status.textContent = error.message || 'Checkout could not be opened. Please try again.';
      button.removeAttribute('aria-busy');
      if (mayHaveAdded) {
        status.textContent = 'Your item may already be in the cart. Please review it before continuing. ';
        const review = document.createElement('a');
        review.href = cartRoot + 'cart'; review.textContent = 'Review your cart';
        status.append(review);
      } else {
        pending = false; button.disabled = false;
        selectionControls.forEach(control => { control.disabled = false; });
      }
    }
  });
})();
